import { StyleButton } from "../components/Styled";
export default function Button({ content, onClick }) {
  return <StyleButton onClick={onClick}>{content}</StyleButton>;
}
